import { InvestorType } from 'further-types/investor';

export const baseInvestorTypeLabel = {
  [InvestorType.EverydayInvestor]: 'Everyday investor',
  [InvestorType.SophisticatedInvestor]: 'Sophisticated investor',
  [InvestorType.HighNetWorthInvestor]: 'High net worth investor',
  [InvestorType.ProfessionalClient]: 'Professional client',
};

export const investorTypeLabel = {
  ...baseInvestorTypeLabel,
  [InvestorType.Advised]: 'Advised',
  [InvestorType.ClassificationSkipped]: 'Classification skipped',
};

export const baseInvestorTypeLabels = (
  [
    InvestorType.EverydayInvestor,
    InvestorType.SophisticatedInvestor,
    InvestorType.HighNetWorthInvestor,
    InvestorType.ProfessionalClient,
  ] as const
).map((type) => ({
  value: type,
  label: baseInvestorTypeLabel[type],
}));

export const investorTypeLabels = Object.values(InvestorType).map((type) => ({
  value: type,
  label: investorTypeLabel[type],
  disabled: type === InvestorType.ClassificationSkipped,
}));
